var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileLogoFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_837_3131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.275 2.33778C1.275 1.75097 1.7507 1.27528 2.3375 1.27528H12.1125C12.6993 1.27528 13.175 1.75097 13.175 2.33778V5.50008H14.45V2.33778C14.45 1.04681 13.4035 0.000276566 12.1125 0.000276566H2.3375C1.04654 0.000276566 3.8147e-06 1.04681 3.8147e-06 2.33778V14.6628C3.8147e-06 15.9537 1.04654 17.0003 2.3375 17.0003H8.4V15.7253H2.3375C1.7507 15.7253 1.275 15.2496 1.275 14.6628V2.33778Z",
    fill: "#3880F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97501 5.10045H8.92501",
    stroke: "#3880F7",
    strokeWidth: 1.275,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97501 8.50054H7.22501",
    stroke: "#3880F7",
    strokeWidth: 1.275,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7002 10.7599C15.7002 8.69218 15.7001 6.14253 12.9377 6.20068C10.131 6.25977 10.2001 8.692 10.2001 10.7597H11.2001C11.2001 9.20693 11.2002 7.20487 12.9377 7.20487C14.6752 7.20487 14.7002 9.20693 14.7002 10.7597L15.7002 10.7599Z",
    fill: "#3880F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 12.9275C16.5 12.2929 15.9849 11.7778 15.3505 11.7778H10.6497C10.0151 11.7778 9.50001 12.2929 9.50001 12.9275V15.2267C9.50001 15.8611 10.0151 16.3762 10.6497 16.3762H15.3505C15.9849 16.3762 16.5 15.8611 16.5 15.2267V12.9275Z",
    stroke: "#3880F7",
    strokeWidth: 1.09632
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_837_3131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLogoFilled);
export default __webpack_public_path__ + "static/media/file-logo-filled.d958d6d6e27142eac0bbb3fce8819de4.svg";
export { ForwardRef as ReactComponent };